/*
 * Registers the True Relevance themes with the app.
 *
 * The two built-in Backstage themes are switched off in app-config.yaml (`app.extensions`), so the
 * appearance picker offers only the brand ones — a portal that ships its own brand shouldn't also
 * offer the generic look.
 */
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { trDarkTheme, trLightTheme } from './trThemes';

const trLightThemeExtension = ThemeBlueprint.make({
  name: 'tr-light',
  params: {
    theme: {
      id: 'tr-light',
      title: 'True Relevance',
      variant: 'light',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={trLightTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

const trDarkThemeExtension = ThemeBlueprint.make({
  name: 'tr-dark',
  params: {
    theme: {
      id: 'tr-dark',
      title: 'True Relevance Dark',
      variant: 'dark',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={trDarkTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [trLightThemeExtension, trDarkThemeExtension],
});
